/**
 * Converte um username simples para um e-mail interno usado no Lumi Auth.
 * O utilizador nunca vê ou escreve este e-mail.
 * Ex: "Admin" → "admin@rcf.internal"
 */
export function usernameToEmail(username: string): string {
  return `${username.toLowerCase().trim().replace(/\s+/g, '.')}@rcf.internal`
}

/**
 * Valida um nome de utilizador: só letras, números, pontos, hífens e underscores.
 */
export function isValidUsername(username: string): boolean {
  return /^[a-zA-Z0-9._-]{3,32}$/.test(username.trim())
}
